import React from 'react';
import PropTypes from 'prop-types';
import { useRecoilValue } from 'recoil';
import { useIsMobile } from '../../recoil';
import { DesktopHeader } from './DesktopHeader';
import { MobileHeader } from './MobileHeader';

export const Header = ({ children, onBackClick, isGroupLogo, shouldShowBackButton = true }) => {

  const isMobile = useRecoilValue(useIsMobile);
  return isMobile
    ? <MobileHeader onBackClick={onBackClick} shouldShowBackButton={shouldShowBackButton} >{children}</MobileHeader>
    : <DesktopHeader isGroupLogo={isGroupLogo}>{children}</DesktopHeader>;

};

Header.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]),
  onBackClick: PropTypes.func,
  isGroupLogo: PropTypes.bool,
  shouldShowBackButton: PropTypes.bool
};
